const baseEvent = {
  eventCategory: 'Optimizely FX',
  customMetrics: {},
  customVariables: {},
  _clear: true
}

export default {
  onOptimizelydecision: (decision) => ({
    ...baseEvent,
    'event': 'optimizely-decision',
    'optimizely-flagKey': decision.flagKey,
    'optimizely-ruleKey': decision.ruleKey,
    'optimizely-variationKey': decision.variationKey,
  }),
}
